import { ListItemText, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";

export interface WorkplaceInfoProps {
  workplaceId: string;
  workplaceName: string;
}

export function WorkplaceInfo(props: WorkplaceInfoProps) {
  const { workplaceId, workplaceName } = props;

  if (!isDefined(workplaceId) || !isDefined(workplaceName)) {
    return null;
  }

  return (
    <ListItemText
      primary={
        <Text
          semibold
          variant="body1"
          sx={(theme) => ({ textWrap: "balance", color: theme.palette.text.secondary })}
        >
          {workplaceName}
        </Text>
      }
    />
  );
}
